import { render, staticRenderFns } from "./PrimitiveBindingModal.vue?vue&type=template&id=7e5e8380&scoped=true&"
import script from "./PrimitiveBindingModal.vue?vue&type=script&lang=js&"
export * from "./PrimitiveBindingModal.vue?vue&type=script&lang=js&"
import style0 from "./PrimitiveBindingModal.vue?vue&type=style&index=0&id=7e5e8380&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e5e8380",
  null
  
)

export default component.exports